module.exports = __webpack_public_path__ + "img/books-stack-of-three-red.875b0996.svg";